import { Sparkle } from "lucide-react";

const WORDS = ["Birthdays", "Graduations", "New babies", "Anniversaries", "Welcome home", "Big wins", "Just because"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display font-bold text-5xl sm:text-7xl px-6 ${i % 2 ? "text-stroke" : ""}`}>{w}</span>
        <Sparkle className="w-9 h-9 fill-[var(--sun)] text-[var(--ink)]" strokeWidth={2} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee" className="marquee-wrap border-y-[3px] border-[var(--ink)] bg-[var(--sun)] py-6 overflow-hidden -rotate-1 scale-[1.02]">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
